import React from 'react';

interface IconProps {
  color?: string;
  size?: number;
  width?: number;
  height?: number;
}

const SlackIcon: React.FC<IconProps> = ({ color = '#4A154B', size, width = 28, height = 28 }) => {
  const w = size || width;
  const h = size || height;
  
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" width={w} height={h}>
      {/* Slack logo - multi-colored by default, single color when specified */}
      <path fill={color === '#4A154B' ? '#E01E5A' : color} d="M94.12 315.1c0 25.9-21.16 47.06-47.06 47.06S0 341 0 315.1c0-25.9 21.16-47.06 47.06-47.06h47.06v47.06zm23.72 0c0-25.9 21.16-47.06 47.06-47.06s47.06 21.16 47.06 47.06v117.84c0 25.9-21.16 47.06-47.06 47.06s-47.06-21.16-47.06-47.06V315.1z"/>
      <path fill={color === '#4A154B' ? '#36C5F0' : color} d="M164.9 91.06c-25.9 0-47.06-21.16-47.06-47.06S139 0 164.9 0s47.06 21.16 47.06 47.06v47.06H164.9zm0 23.72c25.9 0 47.06 21.16 47.06 47.06s-21.16 47.06-47.06 47.06H47.06C21.16 208.9 0 187.74 0 161.84s21.16-47.06 47.06-47.06H164.9z"/>
      <path fill={color === '#4A154B' ? '#2EB67D' : color} d="M401.04 161.84c0-25.9 21.16-47.06 47.06-47.06S495.16 139 495.16 161.84s-21.16 47.06-47.06 47.06h-47.06v-47.06zm-23.72 0c0 25.9-21.16 47.06-47.06 47.06s-47.06-21.16-47.06-47.06V43.94c0-25.9 21.16-47.06 47.06-47.06s47.06 21.16 47.06 47.06v117.9z"/>
      <path fill={color === '#4A154B' ? '#ECB22E' : color} d="M330.26 415.06c25.9 0 47.06 21.16 47.06 47.06s-21.16 47.06-47.06 47.06-47.06-21.16-47.06-47.06v-47.06h47.06zm0-23.72c-25.9 0-47.06-21.16-47.06-47.06s21.16-47.06 47.06-47.06h117.84c25.9 0 47.06 21.16 47.06 47.06s-21.16 47.06-47.06 47.06H330.26z"/>
    </svg>
  );
};

export default SlackIcon;
